import Vue from 'vue'

const common = Vue.mixin({
  data: () => {
    return {
      loader: null,
      loaderMax: null,
      isLoading: null
    }
  },
  methods: {
    checkBlong () {
      console.log('hello')
    },
    generateUuid () {
      let chars = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.split('')
      for (let i = 0, len = chars.length; i < len; i++) {
        switch (chars[i]) {
          case 'x':
            chars[i] = Math.floor(Math.random() * 16).toString(16)
            break
          case 'y':
            chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16)
            break
        }
      }
      return chars.join('')
    },
    categoryText (text) {
      var str = ''
      switch (text) {
        case 'None':
          str = ' _ '
          break
        case 'Mental':
          str = '心'
          break
        case 'Skill':
          str = '技'
          break
        case 'Health':
          str = '体'
          break
        case 'Living':
          str = '生'
          break
      }
      return str
    },
    onLoading () {
      if (this.loader === null) {
        this.loader = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        setTimeout(() => {
          if (this.loader) {
            this.loader.close()
            this.loader = null
          }
        }, 15000)
      }
    },
    onLoadingMaxTimeout (value) {
      if (this.loaderMax === null) {
        this.loaderMax = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        if (value) {
          setTimeout(() => {
            if (this.loaderMax) {
              this.loaderMax.close()
              this.loaderMax = null
            }
          }, value * 1000)
        }
      }
    },
    offLoadingMaxTimeout () {
      if (this.loaderMax) {
        this.loaderMax.close()
        this.loaderMax = null
      }
    },
    onSending () {
      if (this.loader === null) {
        this.loader = this.$loading({
          lock: true,
          text: 'Sending',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        setTimeout(() => {
          if (this.loader) {
            this.loader.close()
            this.loader = null
          }
        }, 15000)
      }
    },
    offLoading () {
      if (this.loader) {
        this.loader.close()
        this.loader = null
      }
    },
    dataInitialize () {
      if (this.init === true) {
        return
      }
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      var vm = this
      vm.$store.dispatch('authUser/initUser')
      vm.$store.dispatch('group/init')
      vm.$store.dispatch('user/init')
      vm.$store.dispatch('routine/init')
      vm.$store.dispatch('routineGroup/init')
      vm.$store.dispatch('routineRef/init')
      vm.$store.dispatch('routineSelf/init')
      vm.$store.dispatch('chatRef/init')
      vm.$store.dispatch('chatMessage/init')
      vm.$store.dispatch('authUser/updateUser').then(() => {
        vm.$store.dispatch('group/subscribe').then(() => {
          vm.$store.dispatch('user/subscribe').then(() => {
            vm.$store.dispatch('routine/subscribe').then(() => {
              vm.$store.dispatch('routineGroup/subscribe').then(() => {
                vm.$store.dispatch('routineRef/subscribe').then(() => {
                  vm.$store.dispatch('routineSelf/subscribe').then(() => {
                    vm.$store.dispatch('chatRef/subscribe').then(() => {
                      vm.$store.dispatch('chatStatics/subscribe').then(() => {
                        vm.$store.dispatch('dispatch/setLoading', false)
                        vm.$store.dispatch('authUser/init', true)
                        vm.isLoading = false
                      })
                    })
                  })
                })
              })
            })
          })
        })
      })
    }
  }
})
export default common



// WEBPACK FOOTER //
// ./src/utils/common.js